<template lang="pug">
div
  el-card.card-container(shadow="hover")
    table-generica(
      :colunas="colunas",
      :botoesAcao="isVisualizar ? null : botoesAcao",
      :dados='dados'
      :disableCheck="disableCheck"
      :isVtn="!isVisualizar"
      @parcelaAdicionada="parcelaAdicionada($event)"
    )
</template>

<script>
import { mapActions } from 'vuex'
import TableGenerica from '@/components/TableGenerica'
import Util from '@/utils/utils'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    TableGenerica
  },

  props: {
    dados: {
      type: Array,
      required: true
    },
    isVisualizar: {
      type: Boolean,
      default: true
    },
    processo: {
      type: Object
    },
    isCheckBox: {
      type: Boolean,
      default: true
    },
    disableCheck: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      colunas: [
        {
          prop: 'numero',
          label: 'PMT',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'saldoDevedorFormatado',
          label: 'Saldo devedor (DV)',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'jurosFormatado',
          label: 'Juros',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'correcaoFormatada',
          label: 'Correção',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'amortizacaoFormatada',
          label: 'Amortização',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'valorFormatado',
          label: 'Prestação (PMT)',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'dataVencimentoFormatada',
          label: 'Vencimento',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'status',
          label: 'Status',
          width: 'auto',
          formatter: Util.formatEmptyRow
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      findUpfByVigencia: 'vtn/findUpfByVigencia'
    }),

    botoesAcao (parcela) {
      const acoes = []
      const status = parcela.status

      if (status === 'PAGA') {
        acoes.push({
          click: this.visualizar.bind(this, parcela),
          icon: 'visibility',
          title: 'Visualizar DAR',
          active: true
        })
      } else
      if (status === 'EMITIDA') {
        acoes.push({
          click: this.acusar.bind(this, parcela),
          icon: 'edit',
          title: 'Acusar pagamento',
          active: true
        })
      } else
      if (status === 'CRIADO' || status === 'ADIANTADA' || status === 'NORMAL') {
        acoes.push({
          click: this.emitir.bind(this, parcela),
          icon: 'edit',
          title: 'Emitir DAR',
          active: true
        })
      }
      return acoes
    },

    async emitir (parcela) {
      const upfExiste = await this.findUpfByVigencia({
        ano: parcela.dataVencimento[0],
        mes: parcela.dataVencimento[1]
      })
      if (upfExiste) {
        this.$router.push({
          name: 'EMITIR_DAR',
          params: {
            processo: this.processo,
            parcela: parcela
          }
        })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          `Não existe UPF cadastrada para a data ${parcela.dataVencimentoFormatada}`
        )
      }
    },

    async visualizar (parcela) {
      this.$router.push({
        name: 'VISUALIZAR_DAR',
        params: {
          processo: this.processo,
          parcela: parcela
        }
      })
    },

    acusar (parcela) {
      this.$router.push({
        name: 'EMITIR_DAR',
        params: {
          processo: this.processo,
          parcela: parcela,
          isAcusarEntrega: true
        }
      })
    },

    parcelaAdicionada (parcelasSelecionadasVtn) {
      this.$emit('parcelaAdicionada', parcelasSelecionadasVtn)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/TabelaAmortizacao.vue